import { merge } from "lodash";

import {
  ICustomSubscriptionParams,
  ICustomSubscriptionPatchParams,
  ICustomSubscriptionRequestParams,
} from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";

import { IJSONAPISubscriptionCollection } from ".";

interface IJSONAPISubscription {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPICustomSubscriptionRequestCollection {
  [IDataKeys.customSubscriptionRequest]: IJSONAPISubscription;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class CustomSubscriptionService {
  static requestSubscription = (
    data: ICustomSubscriptionRequestParams
  ): Promise<IJSONAPICustomSubscriptionRequestCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.CUSTOM_SUBSCRIPTION_REQUESTS,
          data,
        });
        resolve(response as IJSONAPICustomSubscriptionRequestCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_CUSTOM_SUBSCRIPTION_REQUEST);
        reject(error);
      }
    });

  static deleteRequest = (requestId: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.CUSTOM_SUBSCRIPTION_REQUEST(requestId),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_CUSTOM_SUBSCRIPTION_REQUEST);
        reject(error);
      }
    });

  static createSubscription = (
    data: ICustomSubscriptionParams
  ): Promise<IJSONAPISubscriptionCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.CUSTOM_SUBSCRIPTIONS,
          data,
        });
        resolve(response as IJSONAPISubscriptionCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_CUSTOM_SUBSCRIPTION);
        reject(error);
      }
    });

  static editSubscription = (
    subscriptionId: string,
    data: ICustomSubscriptionPatchParams
  ): Promise<IJSONAPISubscriptionCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.CUSTOM_SUBSCRIPTION(subscriptionId),
          data,
        });
        resolve(response as IJSONAPISubscriptionCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_SUBSCRIPTION);
        reject(error);
      }
    });

  static getSubscriptionRequests = (queryParams?: {
    [key: string]: any;
  }): Promise<IJSONAPICustomSubscriptionRequestCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const subscriptions = await APIService.get({
          path: API_ENDPOINTS.CUSTOM_SUBSCRIPTION_REQUESTS,
          data: queryParams,
        });

        resolve(
          merge(
            { [IDataKeys.customSubscriptionRequest]: {} }, // if data is empty, return empty object for key
            subscriptions
          ) as IJSONAPICustomSubscriptionRequestCollection
        );
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_CUSTOM_SUBSCRIPTION_REQUESTS);
        reject(error);
      }
    });
}
